import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-20" data-mp="3c1mguec58dw2">
      <p className={`mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wider ${dark ? "text-gold-light" : "text-navy"}`} data-id="element-21" data-mp="3h0pbr5yet3qb">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-22" data-mp="324zx5svjzsvm" />
        The special offer ends in:
      </p>
      <div className="flex items-start gap-2 sm:gap-3" data-id="element-23" data-mp="373b8y95esdgh">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-24" data-mp="10dmvdcovu13s" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-25" data-mp="10aii7ptfvv0z">
              <span className="flex h-16 w-16 items-center justify-center rounded-xl bg-navy font-serif text-3xl font-bold tabular-nums text-white shadow-lg ring-1 ring-gold/40 sm:h-20 sm:w-20 sm:text-4xl" data-id="element-26" data-mp="15a51afvy85hp">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/70" : "text-muted"}`} data-id="element-27" data-mp="17qq64md98boq">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-2xl font-bold sm:pt-5 ${dark ? "text-gold-light" : "text-navy"}`} data-id="element-28" data-mp="f1sn2h17yaux">:</span>}
          </React.Fragment>)}
      </div>
      <p className={`mt-3 text-sm font-medium ${dark ? "text-white/80" : "text-muted"}`} data-id="element-29" data-mp="o30hup4j0tk9">Limited-time launch pricing</p>
    </div>;
}